// extracted by mini-css-extract-plugin
module.exports = {"socials":"socials_socials__F8l5c","icon":"socials_icon__SEMb7"};